import { render } from "./charts-comparison-table.vue?vue&type=template&id=1312fa04&scoped=true&ts=true"
import script from "./charts-comparison-table.vue?vue&type=script&lang=ts"
export * from "./charts-comparison-table.vue?vue&type=script&lang=ts"

import "./charts-comparison-table.vue?vue&type=style&index=0&id=1312fa04&lang=scss&scoped=true"
import "./charts-comparison-table.vue?vue&type=style&index=1&id=1312fa04&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1312fa04"]])

export default __exports__